const timesToTest = 5;
const arrTimes = [];
const testImage = import.meta.env.VITE_API_BASE + '/images/logo.png'; // small image in your server
const dummyImage = new Image();

/** test and average time took to download image from server, returns a Promise */
export function testLatency(): Promise<number> {
  let i = 0; // start

  return new Promise((resolve) => {
    function runTest(): void {
      const tStart = new Date().getTime();
      if (i < timesToTest - 1) {
        dummyImage.src = testImage + '?t=' + tStart;
        dummyImage.onload = () => {
          const tEnd = new Date().getTime();
          const tTimeTook = tEnd - tStart;
          arrTimes[i] = tTimeTook;
          i++;
          runTest();
        };
      } else {
        const sum = arrTimes.reduce((a, b) => a + b);
        const avg = sum / arrTimes.length;
        resolve(avg);
      }
    }
    runTest();
  });
}
